import React from 'react';
import { Tooltip } from 'antd';
import moment from 'moment';
import DateCellContent from '../../../../../shared/ui/DateCellContent/DateCellContent';
import {
  modalActionTypes,
  modalTypes,
  useModalDispatch,
} from '../../../../../shared/lib/toggleModalVisble';
import { useShutdownAccesses } from '../../../../../shared/lib/hooks/useShutdownAccesses';
import ShutdownTag from '../../../../../shared/ui/ShutdownTag/ShutdownTag';
import styles from './Content.module.scss';

const Cell = ({ shutdown, tooltipTitle, onClick }) => {
  const { startDate: start, planEndDate: planEnd } = shutdown || {};

  const startDate = start ? moment(start) : undefined;
  const planEndDate = planEnd ? moment(planEnd) : undefined;

  const hasStartDate = Boolean(startDate?.isValid());
  const hasPlanEndDate = Boolean(planEndDate?.isValid());

  const mainContent = (
    <Tooltip
      title={tooltipTitle || ''}
      placement="topLeft"
    >
      <DateCellContent
        onClick={onClick}
        date={hasPlanEndDate ? planEndDate : undefined}
      />
    </Tooltip>
  );

  return hasStartDate && hasPlanEndDate ? (
    <div className={styles.container}>
      <div>{mainContent}</div>
      <ShutdownTag
        content={`${planEndDate.diff(startDate, 'hours')} ч.`}
        tooltipTitle="Плановая продолжительность"
      />
    </div>
  ) : (
    mainContent
  );
};

const ActiveDate = ({ shutdown }) => {
  const dispatch = useModalDispatch();

  const handleClick = (e) => {
    e.stopPropagation();

    dispatch({
      type: modalActionTypes.setModalData,
      payload: {
        type: modalTypes.changeShutdownPlanEndDate,
        initialValues: shutdown,
      },
    });
  };

  return (
    <Cell
      shutdown={shutdown}
      tooltipTitle={
        shutdown.planEndDate
          ? 'Изменить плановую дату окончания'
          : 'Добавить плановую дату окончания'
      }
      onClick={handleClick}
    />
  );
};

const Content = ({ shutdown }) => {
  const { canChange } = useShutdownAccesses();

  if (!canChange) {
    return <Cell shutdown={shutdown} />;
  }

  return <ActiveDate shutdown={shutdown} />;
};

export default Content;
